import { MenuItem } from "./menu.model";
const currentUser = JSON.parse(localStorage.getItem("currentUser"));
import { Role } from 'src/app/core/Enums/Role';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "Dashboard",
    link: "/",
    isVisible: true,
    icon: "bx bxs-dashboard fa-sm",
  },
  // Risk-Managment
  {
    id: 2,
    label: "Risk Management",
    icon: "dripicons-warning fa-sm",
    isVisible: false,
    subItems: [
      {
        id: 3,
        label: "Risk Assessments Library",
        icon: "dripicons-warning fa-sm",
        isVisible: true,
        link: "/riskmanagement",
        show: false
      },

      {
        id: 4,
        label: "Fleet Status",
        icon: "bx bx-aperture fa-sm",
        isVisible: true,
        link: "/FleetStatusComponent",
      },
      {
        id: 5,
        label: "Index",
        icon: "fas fa-file-alt fa-sm",
        isVisible: true,
        subItems: [
          {
            id: 6,
            label: "Generic",
            isVisible: true,
            link: "/IndexRiskComponent",
          },
          {
            id: 7,
            label: "Vessel’s History",
            isVisible: true,
            link: "/SpecificRiskAssessmentIndex",
          },
        ],
      },

      {
        id: 8,
        label: "Statistics",
        icon: "dripicons-graph-pie fa-sm",
        isVisible: true,
        link: "/Statistics",
      },
      // {
      //   id: 9,
      //   label: "History",
      //   icon: "fas fa-history fa-sm",
      //     isVisible: true,
      //   link: "/UpdatesHistoryComponent",
      // },
    ],
  },

  // Cyber Risk Managment
  {
    id: 10,
    label: "Cyber Risk Management",
    icon: "mdi mdi-shield-lock-outline fa-sm",
    isVisible: false,
    subItems: [
      {
        id: 11,
        label: "Cyber Risk Assessments",
        icon: "bx bxs-bar-chart-alt-2",
        isVisible: true,
        subItems: [
          {
            id: 12,
            label: "Vulnerabilities",
            icon: "bx bxs-bar-chart-alt-2",
            isVisible: true,
            link: "/Vulnerabilities",
          },
          {
            id: 13,
            label: "Cyber Library",
            icon: "bx bxs-bar-chart-alt-2",
            isVisible: true,
            link: "/GenericCyber",
          },
        ],
      },
      {
        id: 14,
        label: "Vessel Status",
        icon: "fas fa-anchor",
        isVisible: true,
        link: "/VesselStatus",
      },
      {
        id: 16,
        label: "Index",
        icon: "fas fa-file-alt fa-sm",
        isVisible: true,
        subItems: [
          {
            id: 17,
            label: "Cyber Risk Assessment Inventory",

            isVisible: true,
            link: "/GenericCyberRAIndex",
          },
          {
            id: 18,
            label: "Vessel's History",
            icon: "bx bxs-bar-chart-alt-2",
            isVisible: true,
            link: "/SpecificCyberRAIndex",
          },
        ],
      },
    ],
  },


  // CREW ASSESSMENT
  {
    id: 8,
    label: "Crew Competency Assessment",
    icon: "fa fa-tools",
    isVisible: false,
    subItems: [
      {
        id: 31,
        label: "Active Assessments",
        icon: "fas fa-copy",
        isVisible: true,
        link: "/crew-manage/assessments",
        menuItem: ''
      },
      {
        id: 32,
        label: "Personal Assessments History",
        icon: "fas fa-history",
        isVisible: true,
        link: "/crew-manage/assessment-record-history",
        menuItem: ''
      },
      {
        id: 33,
        label: "Crew Competency Files",
        icon: "fas fa-users-cog",
        // fas fa-users-cog fa-2x
        isVisible: true,
        menuItem: 'ctrlPanel',
        subItems: [
          {
            id: 34,
            label: "Company’s Assessments Archive",
            isVisible: true,
            link: "/crew-manage/assessment-history",
            menuItem: 'Categories'
          },
          {
            id: 35,
            label: "Categories",
            isVisible: true,
            link: "/crew-manage/categories",
            menuItem: 'Categories'
          },
          {
            id: 36,
            label: "Certificates",
            isVisible: true,
            link: "/crew-manage/crew-certificates",
            menuItem: 'Certificates'
          },

        ],
      },
      {
        id: 37,
        label: "Crew Matrix",
        icon: "fas fa-users-cog",
        isVisible: true,
        menuItem: 'crewmatrix',
        subItems: [

          {
            id: 38,
            label: "User CV ",

            icon: "fas fa-file-alt",
            isVisible: true,
            link: "crew-matrix/usercvlist",
            menuItem: ''
          },

          {
            id: 39,
            label: "Company's Requirements",
            icon: "fas fa-user-friends",
            isVisible: true,
            link: "crew-matrix/companylist",
            menuItem: ''
          },

        ]
      },
    ],
  },
  // Audit Module

  {
    id: 41,
    label: "Audit Module",
    icon: "mdi mdi-file-eye-outline",
    isVisible: false,
    subItems: [

      {
        id: 42,
        label: "View Checklist",
        icon: "mdi mdi-file-eye-outline",
        isVisible: true,
        link: "/audit/ViewCheckllist",
        menuItem: ''
      },
      {
        id: 43,
        label: "View Questions",
        icon: "mdi mdi-file-question-outline",
        isVisible: true,
        link: "/audit/Question",
        menuItem: ''
      },
      {
        id: 44,
        label: "Company Statistics",
        icon: "fas fa-chart-bar",
        // <i class="fa-solid fa-chart-column"></i>
        isVisible: true,
        link: "/audit/Company-Statistics",
        menuItem: ''
      },
      {
        id: 45,
        label: "Checklist Panel",
        icon: "fa-solid fa-list-ul",
        isVisible: true,
        link: "/audit/Checklist-Panel",
        menuItem: ""
      }
    ]
  },


  //crew-matrix
  {
    id: 51,
    label: "Crew Matrix",
    icon: "fas fa-users-cog",
    isVisible: false,
    subItems: [

      {
        id: 52,
        label: "User CV ",

        icon: "fas fa-file-alt",
        isVisible: true,
        link: "crew-matrix/usercvlist",
        menuItem: ''
      },

      {
        id: 54,
        label: "Preferable Experience",
        icon: "fas fa-user-friends",
        isVisible: true,
        link: "crew-matrix/companylist",
        menuItem: ''
      },

    ]
  },

  //crew-dms
  {
    id: 55,
    label: "DMS",
    modulePath: "dms/folder-list",
    // label: "Document Management System",
    icon: "mdi mdi-file",
    isVisible: false,
    // subItems:
    //   [

    //     // {
    //     //   id: 56,
    //     //   label: "Files/Folders",
    //     //   icon: "bx bxs-folder-open",
    //     //   // <i class="fa-solid fa-chart-column"></i>
    //     //   isVisible: true,
    //     //   link: "dms/FolderList",
    //     //   menuItem: ''
    //     // },

    //   ],
  },


  //  GapAnalysis
  {
    id: 61,
    label: " Gap Analysis",
    icon: "fa-solid fa-chart-pie",
    isVisible: false,
    subItems:
      [

        {
          id: 62,
          label: "DBCE Library",
          icon: "bx bx-data",
          isVisible: true,
          menuItem: '',
          subItems: [
            {
              id: 65,
              label: "DBCE Library",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "DbmsLibrary",
              menuItem: ''
            },
            {
              id: 66,
              label: "Gap Analysis",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Gap-AnalysisDbms-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Archive",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Archive",
              menuItem: ''
            },

          ]
        },
        {
          id: 63,
          label: "TMSA Library",
          icon: "mdi mdi-database-cog",
          isVisible: true,
          menuItem: '',
          subItems: [
            {
              id: 67,
              label: "TMSA Library",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Tmsa-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Gap Analysis",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Gap-Analysis-Tmsa-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Archive",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Archive-tmsa",
              menuItem: ''
            }

          ]
        },
        {
          id: 64,
          label: "SIRE 2.0 Library",
          icon: "mdi mdi-database-settings",

          isVisible: true,

          menuItem: '',
          subItems: [
            {
              id: 67,
              label: "SIRE 2.0 Library",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Sire-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Gap Analysis",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Gap-Analysis-Sire-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Archive",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Archive-Sire",
              menuItem: ''
            }

          ]
        },
        {
          id: 65,
          label: "GDPR Library",
          icon: "mdi mdi-database-sync",

          isVisible: true,
          link: "DbmsLibrary",
          menuItem: '',
          subItems: [
            {
              id: 67,
              label: "GDPR Library",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "GDPR-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Gap Analysis",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Gap-Analysis-GDPR-Library",
              menuItem: ''
            },
            {
              id: 67,
              label: "Archive",
              icon: "fas fa-file-alt",
              isVisible: true,
              link: "Archive-gdpr",
              menuItem: ''
            }

          ]
        },

      ]

  },

  //
  {
    id: 71,
    label: "IAIA",
    icon: "fa-solid fa-ship",
    isVisible: false,
    subItems:
      [
        {
          id: 73,
          label: "IAIA Forms List",
          icon: "fa-solid fa-ship",
          isVisible: true,
          link: "IAIA-List",
          menuItem: '',
        },

        // {
        //   id: 72,
        //   label: "Add IAIA Form",
        //   icon: "fa-solid fa-ship",
        //   // <i class="fa-solid fa-ship"></i>
        //   isVisible: true,
        //   link: "Vessel-Form",
        //   menuItem: ''
        // },

      ]

  },


  {
    id: 81,
    label: "Form Matrix",
    icon: "fa-regular fa-file-lines",
    isVisible: false,
    subItems:
      [
        {
          id: 82,
          label: "Generic List",
          icon: "fa-solid fa-list-check",
          isVisible: true,
          link: "Generic-Matrix-List",
          menuItem: '',
        },

        {
          id: 83,
          label: "Specific List",
          icon: "bx bx-aperture fa-sm",
          isVisible: true,
          link: "Specific-Matrix-List",
          menuItem: ''
        },
        // {
        //   id: 84,
        //   label: "Notification",
        //   icon: "fa-regular fa-bell",
        //   // <i class="fa-solid fa-ship"></i>
        //   isVisible: true,
        //   link: "Notification-Form-Matrix",
        //   menuItem: ''
        // },

      ]

  },
  {
    id: 91,
    label: "Academy",
    icon: "fa fa-university",
    isVisible: false,
    menuItem: '',
    link: ''
  },

  //KPi
  {
    id: 30,
    label: "KPI",
    icon: "fa-solid fa-chart-line",
    isVisible: true,
    subItems:
      [
        {
          id: 40,
          label: "KPI",
          icon: "fa-solid fa-chart-line",
          isVisible: true,
          link: "Kpi-List",
          menuItem: '',
        },
        {
          id: 40,
          label: "Category",
          icon: "fa-solid fa-list",
          isVisible: true,
          link: "Category-List",
          menuItem: '',
        },
        {
          id: 40,
          label: "Sub-Category",
          icon: "fa-solid fa-list-alt",
          isVisible: true,
          link: "Sub-Category-List",
          menuItem: '',
        },
        {
          id: 40,
          label: "KPI-Group",
          icon: "fa-solid fa-layer-group",
          isVisible: true,
          link: "Kpi-Group",
          menuItem: '',
        },
        {
          id: 40,
          label: "KPI-Set",
          icon: "fa-solid fa-boxes",
          isVisible: true,
          link: "Kpi-Set",
          menuItem: '',
        },
        {
          id: 40,
          label: "Company",
          icon: "fas fa-building",
          isVisible: true,
          link: "Company",
          menuItem: '',
        }
      ]
  },


  // CONTROL PANEL
  {
    id: 19,
    label: "Settings",
    icon: "bx bx-cog fa-sm",
    isVisible: false,
    subItems: [
      {
        id: 20,
        label: "Users",
        icon: "bx bx-user-circle",
        isVisible: true,
        // link: "/Users",
        menuItem: 'users',
        modulePath: "users/usersList",

      },
      {
        id: 21,
        label: "Users Log",
        icon: "fas fa-clipboard-list",
        isVisible: true,
        // link: "/UsersLog",
        menuItem: 'userLogs',
        modulePath: "logs/userLogs",

      },
      {
        id: 29,
        label: "Actions Log",
        link: "/NotificationDetail",
        icon: "fas fa-file-export",
        isVisible: true,
        // menuItem: 'threat-controls'
      },
      {
        id: 23,
        label: "Vessels",
        icon: "fas fa-ship",
        isVisible: true,
        // link: "/Vessels",
        menuItem: 'isVessel',
        modulePath: "vessels/vessels",

      },
      {
        id: 24,
        label: "Subscription",
        icon: "bx bxl-firefox fa-sm",
        link: "/Subscription",
        isVisible: true,
        menuItem: 'sub'
      },
      {
        id: 25,
        label: "Review",
        link: "/Review",
        icon: "fas fa-database",
        isVisible: false,
        menuItem: 'review',
      },
      {
        id: 26,
        label: "Companies",
        // link: "/Companies",
        icon: "fas fa-building",
        isVisible: false,
        menuItem: 'company',
        modulePath: "company/companies",

      },
      {
        id: 27,
        label: "Hazards and Controls",
        link: "/update-hazards-controls",
        icon: "bx bxs-check-circle",
        isVisible: false,
        menuItem: 'hazards-controls'
      },
      {
        id: 28,
        label: "Threats and Cyber Controls jjj",
        link: "/update-threats-controls",
        icon: "fa fa-ban",
        isVisible: false,
        menuItem: 'threat-controls'
      },


    ],
  },


];

